import getApi from '../../api/apisauceConfig'
import { PatientMutationParams } from '../../model/Patient'
import { deserializePatientResponse, serializePatient } from './mapper/patients.mapper'
import { ApiPatientResource, PatientMutationPayload } from './mapper/patients.model'

export const updatePatient = (
  id: number,
  payload: PatientMutationPayload,
  params?: PatientMutationParams,
) =>
  getApi()
    .put<ApiPatientResource>(`/patients/${id}`, serializePatient(payload), {
      params,
    })
    .then(deserializePatientResponse)
